//Core
import React, {FC} from "react";
import {useAuth0} from "@auth0/auth0-react";
//Images
import {Close} from "@mui/icons-material";
import LogoSvg from "@/assets/svg/logo";
//Styles
import {IconButton, ListItem} from "@mui/material";
import {MobileMenuBody, MobileMenuContainer, MobileMenuHead} from "./MobileMenu.styles";
import {MobileHeaderLogo} from "@/components/layout/mobileHeader/MobileHeader.styles";
import {LoginButton} from "@/components/mainContent/login/Login.styles";
//Hooks
import {useMobileMenu} from "@/components/layout/mobileHeader/mobileMenu/useMobileMenu";
import {buttons} from "@/components/layout/sidebar/content/buttons/SideBarButtons.data";
import {MainTitlesText} from "@/data/mainTitlesText";

type TMobileMenu = {
    toggleMobileMenu: () => void;
}
const MobileMenu: FC<TMobileMenu> = ({toggleMobileMenu}) => {
    const {isLoading, isAuthenticated, logout} = useAuth0();
    const {goToHomepage, goToLogin, goToSignUp, goToPage} = useMobileMenu(toggleMobileMenu);

    return (
        <MobileMenuContainer>
            <MobileMenuHead>
                <MobileHeaderLogo onClick={goToHomepage}>
                    <LogoSvg fill={'#0B0A1A'}/>
                </MobileHeaderLogo>
                <IconButton onClick={toggleMobileMenu} disableRipple>
                    <Close/>
                </IconButton>
            </MobileMenuHead>
            <MobileMenuBody>
                {buttons.map((page) => {
                    return (
                        <ListItem
                            onClick={() => {
                                // !buttonsDisabled &&
                                goToPage(page)
                            }}
                            key={page}
                            // className={buttonsDisabled ? 'disabled' : ''}
                        >
                            {MainTitlesText[page]}
                        </ListItem>
                    );
                })}
                {!isAuthenticated && !isLoading && (
                    <>
                        <ListItem sx={{marginBottom: '1rem !important'}}>
                            <LoginButton onClick={goToLogin}>{'Login'}</LoginButton>
                        </ListItem>
                        <ListItem>
                            <LoginButton className={'signup'} onClick={goToSignUp}>{'Sign up'}</LoginButton>
                        </ListItem>
                    </>
                )}
                {isAuthenticated && (
                    <ListItem>
                        <LoginButton onClick={() => logout({returnTo: window.location.origin})}>
                            {'Logout'}
                        </LoginButton>
                    </ListItem>
                )}
            </MobileMenuBody>
        </MobileMenuContainer>
    );
};

export default MobileMenu;
